import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

const itemUrl = "/erp/items";
const itemDimensionUrl = "/erp/item/dimensions";
const warehouseUrl = "/erp/warehouses";

export const getItemDimensions = createAsyncThunk(
  "ERP_item/getItemDimensions",
  async (params) => {
    try {
      const response = await apiAxios.get(itemDimensionUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createItemDimension = createAsyncThunk(
  "ERP_item/createItemDimension",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(itemDimensionUrl, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateItemDimension = createAsyncThunk(
  "ERP_item/updateItemDimension",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${itemDimensionUrl}/${id}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const deleteItemDimension = createAsyncThunk(
  "ERP_item/deleteItemDimension",
  async (id, { rejectWithValue }) => {
    try {
      await apiAxios.delete(`${itemDimensionUrl}/${id}`);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const exportData = createAsyncThunk(
  'ERP_item/exportData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await apiAxios.get(`${itemDimensionUrl}/export`, {params, responseType: 'blob'});

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'item-dimensions.xlsx'); //or any other extension
      document.body.appendChild(link);
      link.click();
  
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getItems = createAsyncThunk(
  "ERP_item/getItems",
  async (params) => {
    try {
      const response = await apiAxios.get(itemUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const getItem = createAsyncThunk(
  "ERP_item/getItem",
  async (id) => {
    try {
      const response = await apiAxios.get(`${itemUrl}/${id}`)
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createItem = createAsyncThunk(
  "ERP_item/createItem",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(itemUrl, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateItem = createAsyncThunk(
  "ERP_item/updateItem",
  async ({ itemId, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${itemUrl}/${itemId}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const deleteItem = createAsyncThunk(
  "ERP_item/deleteItem",
  async (itemId) => {
    try {
      const response = await apiAxios.delete(`${itemUrl}/${itemId}`);
      return {
        itemId,
        data: response.data
      };
    } catch (error) {
      throw new Error(error.message)
    }
  }
)

export const getWarehouses = createAsyncThunk(
  "ERP_item/getWarehouses",
  async (params) => {
    try {
      const response = await apiAxios.get(warehouseUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

const isRejectedAction = (action) => (action.type.startsWith("ERP_item/")) && action.type.endsWith("/rejected");

const itemSlice = createSlice({
  name: "erp_item",
  initialState: {
    items: [],
    total: 0,
    loading: false,
    error: null,
    gridParams: {
      page: 0,
      pageSize: 100,
      sortModel: [],
      filterModel: {}
    }
  },
  reducers: {
    setGridParams: (state, action) => {
      state.gridParams = { ...state.gridParams, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getItemDimensions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getItemDimensions.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.rows || [];
        state.total = action.payload.total || 0;
      })
      .addCase(getItemDimensions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const { setGridParams, clearError } = itemSlice.actions;
export default itemSlice.reducer